export default "__VITE_PUBLIC_ASSET__0b0225da__"